import _ from 'lodash'
import MAYA from '../maya_api'
import {changeStep} from "../layouts/Content/modules/step";
import {setLoadingContent} from "../layouts/Content/modules/loadingContent";
import {ALL_ALLOW_APPLICATIONS} from "../components/Applications";
import {STEPS} from "../constants";
import CONFIG from "../config";

// ------------------------------------
// Constants
// ------------------------------------
const APP_SET_VAL = 'APP_SET_VAL';
const APP_SET_SERVER_VAL = 'APP_SET_SERVER_VAL';
const APP_CLEAN_VAL = 'APP_SET_OBJ';
const APP_RESET = 'APP_RESET';
const APP_SET_SESSION_NONCE = 'APP_SET_SESSION_NONCE';
const APP_LAUNCH = 'APP_LAUNCH';
const APP_METHOD_CALL = 'APP_METHOD_CALL';
const APP_SESSION_COMPLETE = 'APP_SESSION_COMPLETE';

const CHECK_FIELDS = 'CHECK_FIELDS';

const APP_CALL_METHODS = {
  'setPaymentOption': 'SET_PAYMENT_OPTION',
  'updateAmounts': 'UPDATE_AMOUNTS',
  'checkAccountNumber': 'CHECK_ACCOUNT_NUMBER',
  'onValidatePayment': 'ON_VALIDATE_PAYMENT',
  'initPayment': 'INIT_PAYMENT'
};

const initialState = {
  session_guid: '',
  app_guid: '',
  product_id: '',
  product_data: {},
  x_data: {
    ready_to_submit: false
  }
};

// ------------------------------------
// Actions
// ------------------------------------

function appSetVal(field = '', value, shouldUpdateServer) {
  return async (dispatch, getStore) => {
    if (!field) return console.error('Field not found');

    console.log('SET =>', field, value);

    const data = {};
    data[field] = value;

    if (shouldUpdateServer) {
      const sessionGuid = getStore().app.session_guid;
      await MAYA.setServerSession(sessionGuid, data);
    }

    dispatch({
      type: APP_SET_VAL,
      payload: data
    });

    return true;
  }
}

function appSetServerVal(field = '', value){
  return async (dispatch, getStore) => {
    if (!field) return console.error('Field not found');

    console.log('SET SERVER =>', field, value);

    const data = {};
    data[field] = value;

    const sessionGuid = getStore().app.session_guid;
    await MAYA.setServerSession(sessionGuid, data);

    dispatch({
      type: APP_SET_SERVER_VAL
    });

    return true;
  }
}

function appSetObj(value = {}, shouldUpdateServer) {
  if (!_.isObject(value)) return console.error('Argument not object');

  return async (dispatch, getStore) => {

    if (shouldUpdateServer) {
      const sessionGuid = getStore().app.session_guid;
      await MAYA.setServerSession(sessionGuid, value);
    }

    console.log('SET OBJ =>', value);

    dispatch({
      type: APP_SET_VAL,
      payload: value
    });

    return true;
  };
}

function appCall(method_name, data = null, update_session = true) {
  return async (dispatch, getStore) => {
    const sessionGuid = getStore().app.session_guid;

    if (!method_name || !sessionGuid) {
      return console.error('method_name and session_guid are both required to make an API call to the server');
    }

    console.log('Method call', method_name);

    const result = await MAYA.call(method_name, sessionGuid, data, update_session);

    console.log('Result of call', method_name, result);

    dispatch({
      type: APP_CALL_METHODS[method_name] || APP_METHOD_CALL,
      payload: result || {}
    });

    return result;
  };
}

function appCleanVal(value) {
  if (!value) return console.error('Field not found');

  return function (dispatch, getStore) {
    if (!_.has(getStore().app.x_data, value)) {
      return console.error('Field cant be removed. Field not found', value);
    }

    dispatch({
      type: APP_CLEAN_VAL,
      payload: value
    });
  };
}


function appReset() {
  return {
    type: APP_RESET,
    payload: ''
  }
}

function applicationLaunch(appGuid, product_id, locale, options = {}) {
  return async function (dispatch, getStore) {
    console.log('Launch application', appGuid);

    if(!ALL_ALLOW_APPLICATIONS[appGuid]){
      return dispatch(changeStep(STEPS.APPLICATION))
    }

    dispatch(setLoadingContent(true));
    dispatch(appReset());

    const sessionData = {
      app_guid: appGuid,
      product_id: product_id,
      locale: locale || CONFIG.DEFAULT_LANGUAGE,
    };

    const sessionOptions = {
      version: CONFIG.VERSION,
      nonce: +new Date(),
      utc_offset: -new Date().getTimezoneOffset(),
      extra_data: options
    };

    const result = await MAYA.createSession({sessionData, sessionOptions});

    if (!(result && result.nonce === sessionOptions.nonce)) {
      console.error('Session was not created', result);
      return MAYA.logout();
    }

    const data = {
      session_guid: result.session_guid,
      product_id: result.product_id,
      app_guid: result.app_guid,
      product_data: result.product_data || {},
      x_data: {
        ...result.on_create_result || {},
        ...result.extra_data || {}
      }
    };

    dispatch({
      type: APP_LAUNCH,
      payload: data
    });

    dispatch(setLoadingContent(false));
    dispatch(changeStep(STEPS.APPLICATION))
  }
}

function checkFields(validator = () => false, extraModel = []) {
  return async (dispatch, getStore) => {
    const prevState = getStore().app.x_data.ready_to_submit;

    const result = validator(getStore, extraModel);
    if(result === prevState) return;

    dispatch({
      type: CHECK_FIELDS,
      payload: result
    })
  }
}

function completeSession(){
  return async (dispatch, getStore) => {

    const sessionGuid = getStore().app.session_guid;
    if(!sessionGuid){
      return console.error('Session guid not found');
    }

    await MAYA.completeSession(sessionGuid);

    dispatch({
      type: APP_SESSION_COMPLETE
    })
  }
}

export {
  appSetVal,
  appSetServerVal,
  appSetObj,
  appCleanVal,
  appReset,
  applicationLaunch,
  appCall,
  checkFields,
  completeSession
};

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [APP_SET_VAL]: (state, action) => updateXData(state, action),
  [APP_SET_SERVER_VAL]: (state, action) => state,
  [APP_CLEAN_VAL]: (state, action) => {
    let app = state;
    delete app.x_data[action.payload];
    return app;
  },
  [APP_LAUNCH]: (state, action) => action.payload,
  [APP_RESET]: () => initialState,
  [APP_METHOD_CALL]: (state, action) => updateXData(state, action),
  [CHECK_FIELDS]: (state, action) => ({
    ...state,
    x_data: {
      ...state.x_data,
      ready_to_submit: action.payload
    }
  }),
  [APP_SESSION_COMPLETE]: (state) => state
};


function updateXData(state, action) {
  return {
    ...state,
    x_data: {
      ...state.x_data,
      ...action.payload
    }
  }
}


// ------------------------------------
// Reducer
// ------------------------------------

export default function applicationReducer(state = initialState, action) {
  const applicationMethod = _.find(_.map(APP_CALL_METHODS, (v) => v), (type) => type === action.type);

  const handler = applicationMethod ? ACTION_HANDLERS[APP_METHOD_CALL] : ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/application.js